import React, { useState } from 'react';

import { Collapse } from '@uikit';

import { Minus, Plus } from '../../icons/mono';

type FAQItem = {
  question: string;
  answer: string;
};

type FaqProps = {
  faqItems: FAQItem[];
};

// @todo Add storybook stories when Collapse component will be moved to the new uikit
export const Faq = ({ faqItems }: FaqProps) => {
  const [accordionsState, setAccordionsState] = useState<Record<number, boolean>>({});

  return (
    <ul className="border-y border-base-border-medium">
      {faqItems.map((item, i) => {
        const isOpen = !!accordionsState[i];

        return (
          <li key={i} className="border-b border-base-border-medium last:border-none">
            <button
              className="py-5 flex items-center text-left justify-between font-medium w-full text-h4-a"
              onClick={() => {
                setAccordionsState((oldState) => {
                  return {
                    ...oldState,
                    [i]: !oldState[i],
                  };
                });
              }}
            >
              {item.question}

              {isOpen ? (
                <Minus className="text-base-text-primary icon-xs" />
              ) : (
                <Plus className="text-base-text-primary icon-xs" />
              )}
            </button>

            <Collapse isOpen={isOpen}>
              <p className="pt-2 pb-4 text-sm font-medium text-neutral-500 text-left">
                {item.answer}
              </p>
            </Collapse>
          </li>
        );
      })}
    </ul>
  );
};
